export default __webpack_public_path__ + "media/icons/blog-icon-74196bfb.svg";